import React, { createContext, useState, useEffect, useContext } from 'react';

const PWA_THEME_COLOR = '#f3f0f8';

export const ThemeContext = createContext({
  theme: 'light',
  toggleTheme: () => {},
});

export function ThemeProvider({ children }) {
  // Keep theme locked to light mode.
  const [theme] = useState('light');

  // apply theme to document and persist
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', 'light');
    try {
      localStorage.setItem('theme', 'light');
    } catch (e) {
      // ignore
    }
    // Keep installed PWA browser chrome aligned with the app shell color.
    try {
      const meta = document.querySelector('meta[name="theme-color"]');
      if (meta) {
        meta.setAttribute('content', PWA_THEME_COLOR);
      }

      const appleMeta = document.querySelector('meta[name="apple-mobile-web-app-status-bar-style"]');
      if (appleMeta) {
        appleMeta.setAttribute('content', 'default');
      }
    } catch (e) {
      // ignore DOM issues in non-browser env
    }
  }, []);

  const toggleTheme = () => {};

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

// convenience hook to access theme context anywhere
export function useTheme() {
  return useContext(ThemeContext);
}
